<div class="container-fluid p-4 rounded shadow my-5" id="filtersBox">
  <div class="d-flex justify-content-center">
    <h3 class="badge lime-green-button1 text-white rounded-pill p-4 text-center">
      Lokalni ponudniki
    </h3>
  </div>
  <div class="row g-3 d-flex justify-content-center">
    <div class="col-12 col-md-6 col-lg-4">
      <label for="searchFilter" class="form-label fw-bold">Išči po ključni besedi</label>
      <input type="text" id="searchFilter" class="form-control" placeholder="Išči kmetije" [(ngModel)]="farmNameFilter" (keyup.enter)="applyFilters()">
    </div>
  </div>

  <div class="text-center mt-4">
    <button class="btn btn-secondary fw-bold" (click)="clearFilters()">Počisti izbiro</button>
  </div>
</div>

<app-farm-list [allFarms]="allFarmsShow" [isOnMarketPage]="isOnMarketPage"></app-farm-list>

<div class="text-center m-0">
  <img src="../../assets/images/background/splitLine.png" alt="Split Line" class="split-line-image img-fluid">
</div>

<!-- Map Row -->
 <div class="background-container">
<div class="container p-4 my-5">
  <h3 class="d-flex justify-content-center lime-green-button text-white rounded-pill p-3 fs-5">
    <fa-icon class="me-2 fa-lg" [icon]="faLocationDot"></fa-icon>Lokacije kmetij</h3>
  <app-map [farmLocations]="farmLocations" [interactive]="false"></app-map>
</div>
 </div>
